import React from 'react';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import WorkFormCard from '../../../../works/components/WorkFormCard';
import { connect } from 'react-redux';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

class WorkUpdate extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_WORKS,
            Breadcrumbs.MY_OUTSOURCES_WORKS_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { work: currentWork, location } = this.props;
        const { work: prevWork } = prevProps;

        if ( currentWork !== prevWork ) {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_WORKS_DETAIL.id,
                url: location.pathname,
                description: currentWork.code + ' ' + currentWork.name,
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_OBRA')} breadcrumbs={breadcrumbs}>
                <WorkFormCard workId={this.props.match.params.id}/>
            </PsPage>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        work: state.works.works[ownProps.match.params.id],
    };
};

export const WorkUpdateScreen = connect(mapStateToProps)(WorkUpdate);



// WEBPACK FOOTER //
// ./src/app/my-outsources/work/form/update/WorkUpdateScreen.jsx